import database from '@/firebase.init';
import {
    EmailValidator,
    MinLengthValidator,
    PhoneValidator,
    RequiredValidator,
    ValidationAggregator
} from "../forms/form-validator";

export default {
    data: () => {
        return {
            userMessage: {},
            errors: [],
            firstErrors: {}
        }
    },
    name: 'ContactUs',
    mounted() {
        this.hideDocumentScrollbar();
    },
    destroyed() {
        this.showDocumentScrollbar();
    },
    methods: {
        hideDocumentScrollbar() {
            document.body.style.overflow = 'hidden';
        },
        showDocumentScrollbar() {
            document.body.style.overflow = 'auto';
        },
        sendData() {
            this.storeInFirebase();
        },
        submitForm() {
            this.validateForm();

            if (!this.errors.length) {
                try {
                    this.storeInFirebase();
                    this.$emit('sending-success')
                } catch (e) {
                    this.$emit('sending-error')
                }
            }
        },
        validateForm() {
            const validators = [
                {
                    field: 'userEmail',
                    validators: [
                        RequiredValidator.ofValueAndMessage(this.userMessage.email, '(Required)'),
                        EmailValidator.ofValueAndMessage(this.userMessage.email, '(Invalid email)')
                    ]
                },
                {
                    field: 'userPhone',
                    validators: [
                        PhoneValidator.ofValueAndMessage(this.userMessage.phone, ', Incorrect phone'),
                        MinLengthValidator.ofValueMinLengthAndMessage(this.userMessage.phone, 6, ', Should have at least 6 digits')
                    ]
                },
                {
                    field: 'userMessage',
                    validators: [
                        RequiredValidator.ofValueAndMessage(this.userMessage.message, '(Required)')
                    ]
                }
            ];
            const aggregator = ValidationAggregator.of(validators);
            this.errors = aggregator.getErrors();
        },
        storeInFirebase() {
            database.ref('user-messages').push({
                email: this.userMessage.email,
                phone: this.userMessage.phone || '-',
                message: this.userMessage.message,
            });
        },
        getError(field) {
            return this.errors.find(errors => field === errors.field);
        },
        clearFieldErrors(fieldName) {
            if (this.errors && this.errors.length) {
                this.errors = this.errors.filter(error => error.field !== fieldName);
            }
        }
    }
}
